import React from "react";
import { Container, Row, Col, Card, Button } from "reactstrap";
import { useHistory } from "react-router-dom";

const SuccessRegister = () => {
  const history = useHistory();

  return (
    <Container className="py-5 mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6} className="text-center">
          <Card
            className="shadow-lg border-0 p-5"
            style={{ borderRadius: "24px" }}
          >
            {/* ICON SVG SECTION */}
            <div className="mb-4 d-flex justify-content-center">
              <div
                className="bg-success bg-opacity-10 d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: "120px",
                  height: "120px",
                  backgroundColor: "#e8f5e9", // Hijau muda soft
                }}
              >
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 6L9 17L4 12"
                    stroke="#28a745" // Warna hijau sukses
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="animated-check"
                  />
                </svg>
              </div>
            </div>

            <h2 className="fw-bold text-dark mb-3">
              Pendaftaran Berhasil Terkirim!
            </h2>

            <p className="text-muted mb-4 px-3" style={{ lineHeight: "1.7" }}>
              Terima kasih telah melengkapi data Anda. Saat ini berkas telah{" "}
              <strong className="text-dark">masuk dalam antrean sistem</strong>{" "}
              dan sedang dalam proses tinjauan oleh tim verifikator kami.
            </p>

            <div
              className="p-3 mb-4 rounded-3"
              style={{
                backgroundColor: "#f8f9fa",
                border: "1px dashed #dee2e6",
              }}
            >
              <small className="text-muted">
                <i className="fa fa-info-circle me-2"></i>
                Pemberitahuan selanjutnya akan dikirimkan melalui email Anda.
              </small>
            </div>

            <div className="d-grid">
              <Button
                color="primary"
                size="lg"
                className="fw-bold shadow-sm py-3 border-0"
                style={{
                  borderRadius: "15px",
                  background: "linear-gradient(45deg, #0d6efd, #004dc0)",
                }}
                onClick={() => history.push("/")}
              >
                <i className="fa fa-home me-2"></i> Kembali ke Beranda
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      <style>
        {`
          @keyframes drawCheck {
            to { stroke-dashoffset: 0; }
          }
          .animated-check {
            stroke-dasharray: 50;
            stroke-dashoffset: 50;
            animation: drawCheck 0.8s ease-in-out forwards;
          }
        `}
      </style>
    </Container>
  );
};

export default SuccessRegister;
